export default __webpack_public_path__ + "static/media/juan.6960ae3f.jpg";